import "./Navigatorbar.css";
import { ReactComponent as Image } from "../../assets/images/logo/logo.svg";

import { useState } from "react";
import { NavLink } from "react-router-dom";
import routes from "../../routes/routeDefinitions";
import { Menu } from "@mui/icons-material";

const Navigationbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const onMenuClick = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeMenu = () => {
    setIsNavOpen(false);
  };

  return (
    <>
      {isNavOpen && (
        <div
          onClick={closeMenu}
          className="w-full h-screen fixed z-40 left-0 top-12 bg-black opacity-50"
        ></div>
      )}
      <div className="bg-blue-850 bg-opacity-80 text-white h-12 md:h-20 lg:h-28 w-full px-10 md:px-0 flex md:flex-col items-center md:items-start justify-between md:justify-center fixed z-50">
        <Image className="h-6 w-16 md:hidden" />

        <div className="md:hidden" onClick={onMenuClick}>
          <Menu />
        </div>
        <ul
          className={`${
            isNavOpen ? "flex" : "hidden"
          } transform transition-all md:transition-none duration-200 ease-linear bg-blue-850 md:bg-transparent absolute z-50 shadow-md md:shadow-none py-4 md:py-0 left-0 top-10 w-full md:w-2/3 lg:w-1/2 mx-auto md:static md:flex flex-col items-center md:items-start md:flex-row justify-between text-lg lg:text-xl`}
        >
          <li className="linksLi" onClick={closeMenu}>
            <NavLink
              className={({ isActive }) =>
                isActive ? "links active" : "links"
              }
              to={routes.home.path}
            >
              {routes.home.name}
            </NavLink>
          </li>
          <li className="linksLi" onClick={closeMenu}>
            <NavLink
              className={({ isActive }) =>
                isActive ? "links active" : "links"
              }
              to={routes.suppliers.path}
            >
              {routes.suppliers.name}
            </NavLink>
          </li>

          <Image className="h-12 hidden md:block" />

          <li className="linksLi" onClick={closeMenu}>
            <NavLink
              className={({ isActive }) =>
                isActive ? "links active" : "links"
              }
              to={routes.about.path}
            >
              {routes.about.name}
            </NavLink>
          </li>
          <li className="linksLi" onClick={closeMenu}>
            <NavLink
              className={({ isActive }) =>
                isActive ? "links active" : "links"
              }
              to={routes.contact.path}
            >
              {routes.contact.name}
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navigationbar;
